module.exports = __webpack_public_path__ + "static/media/debug.08709089.jpg";